///注意，线上环境采用,api基础接口路径前缀
// const HBASE = "https://statistic.hatlab.cn/statistic/"
const HBASE = "https://statistic77.hatlab.cn/statistic/"

// 引用axios
var axios = require('axios')

// 自定义判断元素类型JS
function toType(obj) {
  return ({}).toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase()
}

// 参数过滤函数
function filterNull(o) {
  for (var key in o) {
    if (o[key] === null) {
      delete o[key]
    }
    if (toType(o[key]) === 'string') {
      o[key] = o[key].trim()
    } else if (toType(o[key]) === 'object') {
      o[key] = filterNull(o[key])
    } else if (toType(o[key]) === 'array') {
      o[key] = filterNull(o[key])
    }
  }
  return o
}

/*
  接口处理函数
  这个函数每个项目都是不一样的，我现在调整的是适用于
  https://cnodejs.org/api/v1 的接口，如果是其他接口
  需要根据接口的参数进行调整。参考说明文档地址：
  https://cnodejs.org/topic/5378720ed6e2d16149fa16bd
  主要是，不同的接口的成功标识和失败提示是不一致的。
  另外，不同的项目的处理方法也是不一致的，这里出错就是简单的alert
*/
function apiAxios(method, url, params,systemParam, success) {
  if (params) {
    params = filterNull(params)
  }
  //现在是散的，组成新的param
  var newParam = {
    param: JSON.stringify(params),
    systemParam: JSON.stringify(systemParam),
  }
  // console.log("参数:"+JSON.stringify(newParam))

  ///获取完整的url
  var totalUrl = ""
  if (url.startsWith('https://')) {
    totalUrl = url
  } else {
    ///前缀用于proxy
    totalUrl = HBASE+url
  }
  axios({
    method: method,
    url: totalUrl,
    data: method === 'POST' || method === 'PUT' ? newParam : null,
    params: method === 'GET' || method === 'DELETE' ? newParam : null,
    withCredentials: false
  }).then(function (res) {
    var getRes = res.data

    console.log("打印数据:"+JSON.stringify(getRes.status))
    //成功的返回
    if (getRes.status.status_code === 0) {
      //返回result数据
      if (success) {
        success(getRes.result)
      }
    } else {
      //失败
      // window.alert('error: ' + JSON.stringify(getRes.status.status_reason))
      // if (failure) {
      //     failure(res.data)
      // } else {
      //     window.alert('error: ' + JSON.stringify(res.data))
      // }
    }
  })
    .catch(function (err) {
      let res = err.response
      if (err) {
        window.alert('api error, HTTP CODE: ' + err)
      }
    })
}

// 此为图片上传，与其余接口略有调整所以额外采用以下方法
function apiAxiosUploadImg(url, newParam, success) {
  axios({
    method: 'POST',
    url: url,
    data: newParam,
    withCredentials: false
  }).then(function (res) {
    var getRes = res.data

    console.log("打印数据:"+JSON.stringify(getRes.status))
    //成功的返回
    if (getRes.status.status_code === 0) {
      //返回result数据
      if (success) {
        success(getRes.result)
      }
    } else {
      //失败
      // window.alert('error: ' + JSON.stringify(getRes.status.status_reason))
      // if (failure) {
      //     failure(res.data)
      // } else {
      //     window.alert('error: ' + JSON.stringify(res.data))
      // }
    }
  })
    .catch(function (err) {
      let res = err.response
      if (err) {
        window.alert('api error, HTTP CODE: ' + err)
      }
    })
}
// 返回在vue模板中的调用接口
export default {
  get: function (params,systemParam, url, success) {
    return apiAxios('GET', url, params,systemParam, success)
  },
  post: function (params,systemParam, url, success) {
    return apiAxios('POST', url, params,systemParam, success)
  },
  put: function (params,systemParam, url, success) {
    return apiAxios('PUT', url, params,systemParam, success)
  },
  delete: function (params,systemParam, url, success) {
    return apiAxios('DELETE', url, params,systemParam, success)
  },
  uploadImg: function (url, newParam, success) {
    return apiAxiosUploadImg(url, newParam, success)
  }
}



// WEBPACK FOOTER //
// ./src/utils/api.js